<template>
  <div id="menu-upload">
    <h1>{{ $t("interactiveMap.title") }}</h1>
    <p>{{ $t("interactiveMap.uploadText") }}</p>
    <a
      v-if="signedURL"
      :href="signedURL"
      class="download-btn"
      download
      target="_blank"
    >{{$t('map.transport.schedules.download')}}</a>
    <!-- <button type="button" class="btn control publish-btn">{{$t('interactiveMap.currentDownload')}}</button> -->
    <!-- File input - csv -->
    <div class="input-container">
      <FileUploader
        :placeholder="$t('menu.file_ph')"
        :type="'.csv'"
        :label="$t('menu.browse')"
        :fileUrl="fileUrl"
        @setFile="setFile"
      />
      <div class="error-msg">
        <span v-if="$v.file.$error">{{ $t("menu.errors.file_required") }}</span>
      </div>
    </div>

    <div class="uploadInfo">{{ alert.status }}</div>
    <!-- validateForm -->
    <button
      type="button"
      class="btn control publish-btn"
      :disabled="isLoading"
      @click="openModal"
    >{{ $t("menu.upload") }}</button>
    <FileUploadAlert :name="alert.name" :status="alert.status" />
    <Modal v-if="modalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title">{{ $t("interactiveMap.uploadAlertQuestion") }}</h6>
      </template>
      <template>
        <div class="modal-body-text">
          <strong>{{ $t("interactiveMap.uploadAlertText") }}</strong>
        </div>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">
            {{
            $t("map.benefits.list.modal.cancel")
            }}
          </span>
          <button
            type=" button"
            class="btn control upload-btn"
            @click="validateForm"
          >{{ $t("menu.upload") }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import S3_Handler from "@/lib/api/s3_handler";
import INTERACTIVE_MAP from "@/lib/api/interactiveMap.js";
const FileUploader = () => import("@/components/FileUploader");
const FileUploadAlert = () => import("@/components/alerts/FileUploadAlert.vue");
const Modal = () => import("@/components/Modal");

const s3 = new S3_Handler();
const api = new INTERACTIVE_MAP();

export default {
  components: {
    FileUploader,
    FileUploadAlert,
    Modal,
  },
  filters: {
    formatDateOnly: function (value, lang) {
      if (!value) return "";
      if (lang == "es") {
        moment.locale("es-do");
      } else {
        moment.locale("en");
      }
      return moment(value).format("L");
    },
  },
  data: function () {
    return {
      file: null,
      fileUrl: null,
      loadingFile: true,
      signedURL: null,
      alert: {
        name: "interactiveMap",
        status: null,
      },
      modalActive: false,
    };
  },
  mounted: async function () {
    try {
      const resp = await api.getUploadStatus("/interactiveMap/sync");
      if (!resp.data.status == true) {
        this.alert.status = "loading";
        await api.statusInterval("/interactiveMap/sync");
        this.loadingFile = false;
        this.alert.status = "success";
      } else {
        this.loadingFile = false;
        this.alert.status = null;
      }
    } catch (error) {
      throw error;
    }
  },
  computed: {
    appLang: function () {
      return this.$store.getters["settings/currentLang"];
    },
  },
  validations: {
    file: {
      required,
    },
  },
  beforeDestroy: function () {
    this.alert.status = null;
  },
  async beforeMount() {
    await this.getFile();
  },
  methods: {
    openModal: function () {
      this.modalActive = true;
    },
    closeModal: function () {
      this.modalActive = false;
    },
    setFile: function (file) {
      this.file = file;
    },
    validateForm: async function () {
      this.$v.$touch();
      if (this.$v.$error) return;
      await this.uploadFile();
    },
    async getFile() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const response = await api.getDownloadLink();

        this.fileUrl = response.url;
        this.signedURL = this.fileUrl;
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    uploadFile: async function () {
      this.loadingFile = true;
      this.closeModal();
      try {
        const timestamp = Date.now();
        const fileResp = await s3.uploadFile(
          `${timestamp}_interactiveMap.csv`,
          this.file
        );
        const { Bucket, Key } = fileResp;
        this.alert.status = "loading";
        await api.postInteractiveFile(fileResp.Location, "prod_interactive");
        const resp = await api.uploadInteractiveMap(Bucket, Key);

        this.alert.status = "success";
        this.loadingFile = false;
        this.file = null;
        this.fileUrl = null;
        if (resp.data.hasOwnProperty("result")) {
          this.alert.status = "";
          for (const key in resp.data.result) {
            if (resp.data.result[key] === 0) {
              this.alert.status += `${this.$t(
                `interactiveMap.table.headings.${key}`
              )}  ${this.$t(`interactiveMap.table.required`)}, `;
            }
          }
          this.loadingFile = false;
          this.file = null;
          this.fileUrl = null;
        } else {
          this.$router.push({ name: "Map Preview" });
        }
      } catch (error) {
        console.log(error, "error");

        this.alert.status = "error";
        this.loadingFile = false;
        throw error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#menu-upload {
  background-color: $white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem 4rem;
}
.download-btn {
  background-color: $black;
  color: $white;
  border-radius: 0;
  padding: 0.5rem 2rem;
  align-self: flex-end;
}
.download-btn:hover {
  color: $white;
}
.input-container {
  width: 40%;
}

.error-msg {
  color: $warn_red;
  font-size: 14px;
}

.drop-container,
.uploadInfo {
  width: 100%;
  height: 7rem;
  background-color: $w_2;
  border: 1px solid $wg_2;
  align-self: center;
  margin: 3rem 0;
  padding: 1rem;
}
.drop-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.uploadInfo {
  overflow-y: scroll;
}
#menu-upload .modal .modal-container {
  width: 30vw !important;
  max-width: 30vw !important;
}
.publish-btn {
  align-self: flex-end;
  background-color: #000;
  border-radius: 0px;
  color: #fff;
}
.publish-btn:hover {
  color: #fff;
}
.controls {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.controls .upload-btn {
  background-color: #000;
  border-radius: 0px;
  color: #fff;
  margin-left: 1rem;
}
.controls .upload-btn:hover {
  color: #fff;
}
.menu-table {
  margin-top: 3rem;
}
.cancel-btn {
  cursor: pointer;
}
.cancel-btn:hover {
  text-decoration: underline;
}
</style>

<style lang="scss">
#menu-upload {
  .VueTables__search-field {
    display: flex;
  }
}
</style>
